// extracted by mini-css-extract-plugin
module.exports = {"root":"NotFound__root--YYNcV","icon":"NotFound__icon--1R34B","description":"NotFound__description--3hntv","button":"NotFound__button--2R3jX","bounce":"NotFound__bounce--1CaLq"};